export const JEEVES_SEARCH_FORM_ID = 'searchPageQueryTermInput';

export const AGATHA_PAGE_SEARCH_FORM_ID = 'agatha-page-search-form-id';

export const GLOBAL_NAV_SEARCH_FORM_ID = 'global-nav-search-form-id';

export const SELECTED_LANGUAGE_OPTION_ID = 'selected-language-filter-list-item-id';

export const UNSPECIFIED_STRATEGY = 'unspecified_strategy';

export const DEFAULT_LEXILE_LEVEL_RANGE = '300-1260';

export const MAX_NUMBER_OF_RECENT_SEARCHES = 3;

export const TIME_DELAY_TO_FETCH_SUGGESTIONS = 300;

export const CLASSNAME_FOR_AGATHA_GENERATED_SUGGESTION = 'agatha-generated-suggestion';

export const CLASSNAME_FOR_JEEVES_GLOBAL_NAV_SUGGESTION = 'jeeves-global-nav-suggestion';

export const CLASSNAME_FOR_LANGUAGE_FILTER_OPTION = 'language-filter-option';

export const SEARCH_BETA_USER_EVENTS = {
  joinedSearchBeta: 'joined_agatha_beta',
  leftSearchBeta: 'left_agatha_beta',
  dismissedOptInBanner: 'dismissed_agatha_opt_in_banner',
};

export const LANGUAGE_OPTIONS = {
  english: {
    languageCode: 'en',
    label: 'English'
  },
  spanish: {
    languageCode: 'es',
    label: 'Espa' + '\u00f1' + 'ol',
  }
};

export const MIN_SLIDER_RANGE = 0;
export const MAX_SLIDER_RANGE = 17;
export const MIN_GRADE_RANGE = 300;
export const MAX_GRADE_RANGE = 1260;

export const GRADE_MARKS = [
  {value: 0, label: '2'},
  {value: 1},
  {value: 2},
  {value: 3},
  {value: 4},
  {value: 5},
  {value: 6},
  {value: 7},
  {value: 8},
  {value: 9},
  {value: 10},
  {value: 11},
  {value: 12},
  {value: 13},
  {value: 14},
  {value: 15},
  {value: 16},
  {value: 17, label: '12'},
];

export const LEXILE_GRADE_MAP = {
  0: {
    grade: 2,
    lexile: 300
  },
  1: {
    grade: 2,
    lexile: 360
  },
  2: {
    grade: 2,
    lexile: 420
  },
  3: {
    grade: 2,
    lexile: 480
  },
  4: {
    grade: 3,
    lexile: 540
  },
  5: {
    grade: 3,
    lexile: 600
  },
  6: {
    grade: 4,
    lexile: 660
  },
  7: {
    grade: 4,
    lexile: 720
  },
  8: {
    grade: 5,
    lexile: 780
  },
  9: {
    grade: 5,
    lexile: 840
  },
  10: {
    grade: 5,
    lexile: 900
  },
  11: {
    grade: 6,
    lexile: 960
  },
  12: {
    grade: 7,
    lexile: 1020
  },
  13: {
    grade: 7,
    lexile: 1080
  },
  14: {
    grade: 8,
    lexile: 1140,
  },
  15: {
    grade: '9-10',
    lexile: 1200
  },
  16: {
    grade: '9-10',
    lexile: 1200
  },
  17: {
    grade: '11-12',
    lexile: 1260
  },
};
